import * as React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { nftJsonState } from "../../states/nftJsonState";
import { nftJsonNoneMetaState } from '../../states/nftJsonNoneMetaState';

type Props = {

}
export const RecievedNFTInfo: React.FC<Props> = (props) => {
  const [attributeStatus, setAttribute] = React.useState(``);
  const nftInfo = useRecoilValue(nftJsonState);
  const nftInfoNoneMeta = useRecoilValue(nftJsonNoneMetaState);
  const DivComponent = styled.div`
    margin-bottom: 80px;
    position: relative;
    margin-top: 40px;
  `;
  const RecievedNFTInfoComponent = styled.div`
    text-align: center;
    font-family: 'Noto Sans JP';
    font-style: normal;
    line-height: 35px;
    align-items: center;
    color: #FFFBFB;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 auto;
    padding: 0;
    position: relative;
    width: 301px;
    border-width: 1px 0px;
    border-style: solid;
    border-color: #FFFBFB;
  `;
  const RecievedNFTInfoNameComponent = styled.p`
    font-weight: 900;
    font-size: 24px;
    margin-bottom: 0;
    margin-top: 20px;
    font-family: 'Noto Sans JP',sans-serif;
  `;
  const RecievedNFTInfoDescriptionComponent = styled.p`
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 0;
    font-family: 'Noto Sans JP',sans-serif;
  `;
  const RecievedNFTInfoAttributeComponent = styled.p`
    font-weight: 400;
    font-size: 16px;
    font-family: 'Noto Sans JP',sans-serif;
  `;

  React.useEffect(()=>{
    (async() => {
      let markup:string = ``;
      if (nftInfoNoneMeta.attributes.length !== 0) {
        nftInfoNoneMeta.attributes.forEach((attributesItem) => {
          markup += `${attributesItem.traitType} : ${attributesItem.value}<br>`;
        });
      }
      setAttribute(`${markup}`);
    })()
  },[]);


  return (
    <DivComponent>
        <RecievedNFTInfoComponent>
            <RecievedNFTInfoNameComponent>{nftInfoNoneMeta.name}</RecievedNFTInfoNameComponent>
            <RecievedNFTInfoDescriptionComponent>{nftInfoNoneMeta.description}</RecievedNFTInfoDescriptionComponent>
            <RecievedNFTInfoAttributeComponent dangerouslySetInnerHTML={{__html:`${attributeStatus}`}}></RecievedNFTInfoAttributeComponent>
        </RecievedNFTInfoComponent>
    </DivComponent>
  );
};